var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8756 26.2646L10.1493 22.7539L6.11194 30.4892L11.0123 29.2311L12.8383 33.9999L16.8756 26.2646ZM19.7833 26.2646L26.5097 22.7539L30.547 30.4892L25.6467 29.2311L23.8207 33.9999L19.7833 26.2646Z",
    fill: "#5C1526"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4458 14.45C31.4458 21.6274 25.6274 27.4458 18.45 27.4458C11.2727 27.4458 5.45425 21.6274 5.45425 14.45C5.45425 7.27265 11.2727 1.45425 18.45 1.45425C25.6274 1.45425 31.4458 7.27265 31.4458 14.45Z",
    fill: "url(#paint0_linear_306_359)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9 14.45C32.9 22.4305 26.4305 28.9 18.45 28.9C10.4695 28.9 4 22.4305 4 14.45C4 6.46949 10.4695 0 18.45 0C26.4305 0 32.9 6.46949 32.9 14.45ZM18.45 27.4458C25.6274 27.4458 31.4458 21.6274 31.4458 14.45C31.4458 7.27265 25.6274 1.45425 18.45 1.45425C11.2727 1.45425 5.45425 7.27265 5.45425 14.45C5.45425 21.6274 11.2727 27.4458 18.45 27.4458Z",
    fill: "#9A4609"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.45 25.9915C24.8242 25.9915 29.9915 20.8242 29.9915 14.45C29.9915 8.07581 24.8242 2.90851 18.45 2.90851C12.0758 2.90851 6.90851 8.07581 6.90851 14.45C6.90851 20.8242 12.0758 25.9915 18.45 25.9915ZM18.45 27.4458C25.6274 27.4458 31.4458 21.6274 31.4458 14.45C31.4458 7.27265 25.6274 1.45425 18.45 1.45425C11.2727 1.45425 5.45425 7.27265 5.45425 14.45C5.45425 21.6274 11.2727 27.4458 18.45 27.4458Z",
    fill: "#D86100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.269 14.0654C19.9814 14.1813 20.3377 14.69 20.3377 15.5913V17.3012C20.3377 17.9043 20.1455 18.3815 19.7611 18.7327C19.38 19.0807 18.8365 19.2547 18.1307 19.2547C16.6661 19.2547 15.9337 18.5455 15.9337 17.1272V15.2136H17.6337V17.2913C17.6337 17.4669 17.6767 17.6028 17.7629 17.6989C17.8524 17.795 17.9683 17.843 18.1108 17.843C18.4157 17.843 18.5681 17.6359 18.5681 17.2217V15.4472C18.5681 15.202 18.5217 15.0296 18.429 14.9302C18.3395 14.8275 18.1987 14.7761 18.0065 14.7761H17.1316L16.8881 13.4738H17.9667C18.1755 13.4738 18.3163 13.4225 18.3892 13.3198C18.4621 13.2137 18.4985 13.0513 18.4985 12.8326V11.3862C18.4985 11.2238 18.4588 11.0979 18.3792 11.0084C18.303 10.9156 18.2003 10.8693 18.0711 10.8693C17.9286 10.8693 17.8159 10.9173 17.7331 11.0134C17.6535 11.1062 17.6138 11.2371 17.6138 11.4061V13.0861H15.9437V11.4061C15.9437 10.7831 16.1292 10.3026 16.5004 9.96461C16.8748 9.62329 17.4315 9.45264 18.1705 9.45264C18.7935 9.45264 19.2955 9.6117 19.6766 9.92981C20.0577 10.2446 20.2482 10.6688 20.2482 11.2023V12.5294C20.2482 12.9437 20.1753 13.2684 20.0295 13.5037C19.8837 13.7356 19.6302 13.8997 19.269 13.9958V14.0654Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_359",
    x1: 18.45,
    y1: 0,
    x2: 18.45,
    y2: 28.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4792F"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.748d6ea337103d3c5f4c67bcb8a32742.svg";
export { ForwardRef as ReactComponent };